import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import otaList from '@blade-sxp/ota-management/components/ota-list.vue';
import otaUpload from '@blade-sxp/ota-management/components/ota-upload.vue';
let default_1 = class extends Vue {
    activeIndex = 1;
    showPage(index) {
        this.activeIndex = index;
    }
    mounted() {
        if (localStorage.getItem('activeIndex') === '2') {
            this.activeIndex = 2;
        }
        else {
            this.activeIndex = 1;
        }
    }
    beforeDestroy() {
        localStorage.setItem('activeIndex', '');
    }
};
default_1 = __decorate([
    Component({
        name: 'Log',
        components: {
            otaList,
            otaUpload
        },
        i18n: {
            messages: {
                'en-us': {
                    updatePackageManagement: 'Update Package Management',
                    taskList: 'Task List'
                },
                zh: {
                    updatePackageManagement: '更新包管理',
                    taskList: '任务列表'
                },
            },
        },
    })
], default_1);
export default default_1;
